define("shared/helpers/are-equal", ["exports", "@ember/component/helper"], function (_exports, _helper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper"eaimeta@70e063a35619d71f

  var _default = (0, _helper.helper)((_ref
  /*, hash*/
  ) => {
    let [arg1, arg2] = _ref;
    return (//need double equals for user and device selectors -iMack
      arg1 == arg2
    );
  } // jshint ignore:line
  );

  _exports.default = _default;
});